import { GridCardListProps } from './GridCardList';

// TODO Update contentfulSection type
export const parseGridCardListData = (
  contentfulSection: any,
): GridCardListProps | null => {
  const {
    displayName,
    subsections,
    metadata: { title },
  } = contentfulSection;

  // Validate that all sections are added in Contentful
  if (!displayName && !subsections && !title) {
    return null;
  }

  const cards = subsections.map((subsection: any) => ({
    image: {
      gatsbyImageData: subsection?.images?.[0]?.desktopImage?.gatsbyImageData,
    },
    title: subsection.displayName,
    description: subsection.body,
  }));

  const GridCardListProps = {
    eyebrow: displayName,
    title: title,
    cards: cards,
  };

  return GridCardListProps;
};
